import { Show, type Component } from 'solid-js';
import Instruments from '~/features/instruments';
import FundPanel from '~/features/fund-panel';
import HoldingsPanel from '~/features/holdings-panel';
import SectorPanel from '~/features/sector-panel';
import { holdingsOpen, openSector } from '~/stores/explore-store';

// The screener, with whatever row you are on opened beside it, and beside that
// whichever of the fund's sections has been opened into a panel: its holdings as
// charts, or one sector expanded into the companies in it. Both are optional and
// both are a quarter wide, so the table keeps the room until it is asked for.
const ExplorePage: Component = () => (
    <>
        <div class='flex-1 min-w-0'>
            <Instruments />
        </div>
        <div class='w-[28rem] shrink-0'>
            <FundPanel />
        </div>
        <Show when={holdingsOpen()}>
            <div class='w-1/4 shrink-0'>
                <HoldingsPanel />
            </div>
        </Show>
        <Show when={openSector()}>
            <div class='w-1/4 shrink-0'>
                <SectorPanel />
            </div>
        </Show>
    </>
);

export default ExplorePage;
